import Highcharts from 'highcharts';

export const lineChartOptions = {
  chart: {
    type: 'spline',
    backgroundColor: '#eef0f3',
    spacing: [10, 0, 0, 0],
  },
  credits: {
    mapText: '',
    mapTextFull: '',
    text: '',
  },
  exporting: {
    chartOptions: {
      title: {
        style: {
          'font-size': '16px',
          'font-weight': 'bold',
          'font-family': 'Arimo, Arial, sans-serif',
        },
      },
      chart: {
        spacing: [10, 10, 10, 10],
      },
      credits: {
        mapText: '',
        mapTextFull: '',
        text: 'IWP – Swiss Inequality Database',
      },
      yAxis: [{ title: { style: { fontSize: '10px' } } }],
    },
    buttons: {
      contextButton: {
        enabled: false,
      },
    },
  },
  title: { text: `` },
  series: [],
  tooltip: {
    backgroundColor: null,
    borderWidth: 0,
    shared: false,
    useHTML: true,
    headerFormat: '<div class="hicharttooltip"><span class="hicharttooltip-title">{series.name}</span>',
    footerFormat: '</div>',
    shadow: false,
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 500,
        },
        chartOptions: {
          legend: {
            itemMarginBottom: 8,
          },
        },
      },
    ],
  },
  plotOptions: {
    series: {
      marker: {
        enabled: true,
      },
    },
  },
  yAxis: [
    {
      title: {
        text: 'Einkommensanteil (in Prozent)',
      },
      labels: {
        formatter: function () {
          return Highcharts.numberFormat(this.value, 0);
        },
      },
    },
  ],
  xAxis: [
    {
      allowDecimals: false,
    },
  ],
};
